import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import { useForm } from "vee-validate";
import { useErrors } from "../utils/api-functions";
import FormInput from "@/ts/form/input.vue";
import FormCheckbox from "@/ts/form/checkbox.vue";
import Submit from "@/ts/form/submit.vue";
import * as Yup from "yup";
import { nl } from "yup-locales";
import { mande } from "mande";


export default /*#__PURE__*/_defineComponent({
  __name: 'general-contact',
  setup(__props, { expose }) {
  expose();

const apiErrors = useErrors();

const success = ref(false);
const loading = ref(false);
const api = mande("/api");
const open = ref(false);

Yup.setLocale(nl);

const { handleSubmit, isSubmitting } = useForm({
    initialValues: {
        first_name: "",
        email: "",
        terms: undefined,
    },
    validationSchema: Yup.object({
        first_name: Yup.string().required().label("Naam"),
        email: Yup.string().email().required().label("Email"),
        terms: Yup.boolean().required(),
    }),
});

const onSubmit = handleSubmit(async (values, { resetForm }) => {
    try {
        loading.value = true;

        // @ts-ignore
        await api.post("general-contact", values);

        success.value = true;

        setTimeout(resetForm, 500);
    } catch (error) {
        apiErrors.parse(error);
    } finally {
        loading.value = false;
    }
});

const __returned__ = { apiErrors, success, loading, api, open, handleSubmit, isSubmitting, onSubmit, FormInput, FormCheckbox, Submit }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})